const FONTS = {
  regular: 'Aeonik',
  medium: 'Aeonik-Medium',
  bold: 'Aeonik-Bold'
}

export default FONTS
